import { useEffect, useState } from "react";
import Opponent from "./Opponent";
import StepNavigation from "./StepNavigation";
import { getFromLocalStorage } from "../../../../utils/webStorage";
import { useDispatch, useSelector } from "react-redux";
import { setOpponentSchoolList } from "../../../../Redux/Actions/LoginActions";
import userService from "../../../../services/user.service";
import { openFailDialog } from "../../../../Redux/Actions/PopupActions";
import { resetVideoStreamingInformation } from "../../../../Redux/Actions/VideoStreamingActions";

import IPCameraVideoStreamingContainer from "../IPCameraVideoStreaming/IPCameraVideoStreamingContainer";
import SeasonInformation from "./SeasonInformation";
import { resetVideoScheduleEventData } from "../../../../Redux/Actions/VideoScheduleAction";

const MultiStepForm = ({ page, setPage, socket }) => {
  const dispatch = useDispatch();
  const schoolName = getFromLocalStorage("schoolName");
  const [opponentName, setOpponentName] = useState("");
  const [opponentSchoolImage, setOpponentSchoolImage] = useState("");
  const steps = ["Select Opponent", "Select Season", "Start Channels"];

  const opponentSchoolList = useSelector(
    (state) => state?.loggedInUser?.schoolList
  );
  const videoScheduleInformation = useSelector(
    (state) => state?.videoScheduleInformation
  );
  const getOpponentSchoolList = (schoolName) => {
    userService
      .getAllSchoolListing()
      .then((res) => {
        var schoolList = [];
        schoolList = res.data.data.schools;
        const filteredSchoolList = schoolList.filter(function (item) {
          return item.schoolName !== schoolName && item?.status === true;
        });
        setOpponentSchoolList(dispatch, filteredSchoolList);
      })
      .catch((err) => {
        openFailDialog(dispatch, {
          open: true,
          message: "Something Went Wrong",
        });
      });
  };

  useEffect(() => {
    getOpponentSchoolList(schoolName);
    return () => {
      resetVideoScheduleEventData(dispatch, [
        "uploadvideoEvent",
        "uploadVideoWeek",
        "uploadVideoWeekName",
        "uploadVideoEventType",
        "uploadVideoOffSeasonEventName",
        "otherEventName",
        "practice",
        "opponentName",
      ]);
      resetVideoStreamingInformation(dispatch);
    };
  }, []);

  useEffect(() => {
    getOpponentSchoolImage();
  }, [videoScheduleInformation?.opponentName]);

  const getOpponentSchoolImage = () => {
    const opponentSchoolImage = opponentSchoolList?.find(
      (item) => item.schoolName === videoScheduleInformation?.opponentName
    );
    setOpponentSchoolImage(opponentSchoolImage?.uploadedLogo?.filePath);
  };
  const pageDisplay = () => {
    switch (page) {
      case 0:
        return (
          <Opponent
            opponentSchoolImage={opponentSchoolImage}
            page={page}
            setPage={setPage}
          />
        );

      case 1:
        return <SeasonInformation page={page} setPage={setPage} />;

      case 2:
        return (
          <IPCameraVideoStreamingContainer
            opponentName={opponentName}
            page={page}
            setPage={setPage}
            socket={socket}
          />
        );

      default:
        break;
    }
  };
  return (
    <div className="white-card mg-bottom-20">
      <StepNavigation steps={steps} currentStep={page} />
      {pageDisplay()}
    </div>
  );
};

export default MultiStepForm;
